const green50 = "#e9f6f6";
const green100 = "#bbe4e3";
const green200 = "#9bd7d6";
const green300 = "#6dc4c3";
const green400 = "#51b9b7";
const green500 = "#25a7a5";
const green600 = "#229896";
const green700 = "#1a7775";
const green800 = "#145c5b";
const green900 = "#104645";
const greens = {
  green50,
  green100,
  green200,
  green300,
  green400,
  green500,
  green600,
  green700,
  green800,
  green900
};
export {
  greens as default,
  green100,
  green200,
  green300,
  green400,
  green50,
  green500,
  green600,
  green700,
  green800,
  green900
};
//# sourceMappingURL=index.es5.js.map
